/* OCC #74: five-minute Undo, current page only. No saved-for-later rollout (#81). */
(() => {
  'use strict';
  if(window.OCCCartRecovery || !window.OCCCartRecoveryCore)return;
  const box=document.querySelector('[data-occ-undo]');if(!box)return;
  const rows=new Map(),copy=x=>JSON.parse(JSON.stringify(x));
  const store={
    put(entry){const row={...copy(entry),id:entry.id||crypto.randomUUID()};rows.set(row.id,row);return {ok:true,row:copy(row)};},
    update(id,changes){const old=rows.get(id);return old?this.put({...old,...changes}):{ok:false};},
    get(id){const row=rows.get(id);return row&&copy(row);},list(){return [...rows.values()].map(copy);}
  };
  let current,busy=false;
  const message=box.querySelector('p'),button=box.querySelector('button');
  function notify(event){
    if(event.type==='undo'){current=event.row;box.hidden=false;button.hidden=false;message.textContent='Removed '+event.row.title+' — '+event.row.variantTitle+'. Undo is available for five minutes on this page.';}
    if(event.type==='review'){box.hidden=false;button.hidden=true;message.textContent=event.message;}
    if(event.type==='restored'){button.hidden=true;message.textContent='Item restored once. Review your updated cart for current totals.';}
  }
  const client=OCCCartVariantCore.create({root:Shopify.routes.root});
  window.OCCCartRecovery=OCCCartRecoveryCore.create({store,client,notify,protectedProducts:[box.dataset.gift],protectedVariants:[box.dataset.protection]});
  button.addEventListener('click',async()=>{if(busy||!current)return;busy=true;button.disabled=true;
    try{await OCCCartRecovery.restore(current.id);}
    catch(error){message.textContent=error.message;button.hidden=true;}
    finally{busy=false;button.disabled=false;}
  });
  setInterval(()=>{if(current?.expiresAt<Date.now()){button.hidden=true;message.textContent='The undo period has ended. Open the product again if you need it.';}},10000);
})();

